import Api from "./Api";
import Csrf from "./Csrf";

export default {   
    
  async update(id,form) {
    await Csrf.getCookie();

    return Api.patch("/positions/"+id, form);
  },
    
  async index() {
    await Csrf.getCookie();

    return Api.get(`/positions?timestamp=${new Date().getTime()}`);
  },
    
  async tableIndex() {
    await Csrf.getCookie();

    return Api.get("/positions/table-index");
  },
    
  async add(form) {
    await Csrf.getCookie();

    return Api.post("/positions", form);
  },
    
  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/positions/" + id);      
      
  },
    
  async show(id) {
    await Csrf.getCookie();

    return Api.get("/positions/" + id);      
      
  },
};